import React from 'react';
import { RadioGroup } from 'react-radio-group';

type Props = {
  data: number,
  title: string,
  resetFn: Function,
  body: Node,
  filterFn: Function,
};

const RadioFilter = ({ filterFn, resetFn, data, title, body }: Props) => {
  return (
    <div className="widget widget-radio">
      <h4>
        {title}
        <span className="float-right" onClick={() => resetFn('')}>
          Reset
        </span>
      </h4>
      <RadioGroup onChange={filterFn} selectedValue={data}>
        <ul>{body}</ul>
      </RadioGroup>
    </div>
  );
};
export default RadioFilter;



// WEBPACK FOOTER //
// ./src/screens/TrekListings/TrekFilters/RadioFilter.jsx